export enum CookieConsentStatus {
  ACCEPTED = "accepted",
  DECLINED = "declined",
  PENDING = "pending"
}

export interface CookieConsentData {
  status: CookieConsentStatus;
  date: string | null;
}

export class CookieConsentManager {
  private static readonly STORAGE_KEY = "cookieConsent";
  private static readonly DATE_STORAGE_KEY = "cookieConsentDate";

  static getConsentStatus(): CookieConsentData {
    const status = localStorage.getItem(this.STORAGE_KEY);
    const date = localStorage.getItem(this.DATE_STORAGE_KEY);

    if (!status) {
      return {
        status: CookieConsentStatus.PENDING,
        date: null
      };
    }

    return {
      status: status as CookieConsentStatus,
      date
    };
  }

  static setConsent(status: CookieConsentStatus): void {
    const date = new Date().toISOString();
    localStorage.setItem(this.STORAGE_KEY, status);
    localStorage.setItem(this.DATE_STORAGE_KEY, date);
  }

  static hasConsent(): boolean {
    const { status } = this.getConsentStatus();
    return status === CookieConsentStatus.ACCEPTED;
  }

  static hasDeclined(): boolean {
    const { status } = this.getConsentStatus();
    return status === CookieConsentStatus.DECLINED;
  }

  static isPending(): boolean {
    const { status } = this.getConsentStatus();
    return status === CookieConsentStatus.PENDING;
  }

  static clearConsent(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.DATE_STORAGE_KEY);
  }

  static shouldShowBanner(): boolean {
    return this.isPending();
  }

  // Optional: Check if consent is expired (e.g., after 1 year)
  static isConsentExpired(maxAgeInDays: number = 365): boolean {
    const { date } = this.getConsentStatus();
    if (!date) return true;

    const consentDate = new Date(date);
    const now = new Date();
    const diffInDays = (now.getTime() - consentDate.getTime()) / (1000 * 60 * 60 * 24);
    
    return diffInDays > maxAgeInDays;
  }
}

// Helper functions for Google Analytics or other tracking
export const initializeTracking = () => {
  if (CookieConsentManager.hasConsent()) {
    // Initialize Google Analytics, Facebook Pixel, etc.
    console.log("Tracking initialized - user has consented to cookies");
    
    // Example: Initialize Google Analytics
    // gtag('config', 'GA_MEASUREMENT_ID');
    
    // Example: Initialize other tracking services
    // initializeFacebookPixel();
    // initializeHotjar();
  }
};

export const disableTracking = () => {
  if (CookieConsentManager.hasDeclined()) {
    // Disable tracking services
    console.log("Tracking disabled - user has declined cookies");
    
    // Example: Disable Google Analytics
    // window.gtag = () => {};
    
    // Example: Disable other tracking
    // disableFacebookPixel();
    // disableHotjar();
  }
};